import { Route, Routes, useLocation } from 'react-router-dom';
import './css/App.css';

import { useContext, useEffect, useRef } from 'react';
import { DContext } from './context/Datacontext';
import Header from './components/blocks/Layout/Header'
import Home from './components/pages/HomePage/Home';
import Footer from './components/blocks/Layout/Footer';
import AboutUs from './components/pages/About';
import PageNotFound from './components/blocks/Layout/NotFound';
import PrivacyPolicy from './components/blocks/Layout/Privacy';
import TermsAndConditions from './components/blocks/Layout/Terms';
import Login from './components/blocks/authentication/Sigin'
import Organisation from './components/pages/Organisation/Organisation';
import SuperAdminsDashboard from './components/pages/SuperAdminManagement/SuperAdminsDashboard';
import UsersAccountCreate from './components/pages/UsersAccountCreate';
import HelpDeskDashboard from './components/pages/HelpDeskManagement/HelpDeskDashboard';
// import AdminDashboard from './components/pages/AdminManagement/AdminDashboard';
// import ManagerDashboard from './components/pages/ManagerManagement/ManagerDashboard';
import RecruiterDashboard from './components/pages/RecruiterManagement/RecruiterDashboard';
import TeamLeadDashboard from './components/pages/TeamLeadManagement/TeamLeadDashboard';
import UserManagement from './components/pages/UserManagement';
import ClientCreate from './components/pages/AdminManagement/ClientCreate';
import UpdateUsers from './components/pages/UpdateUsers';
import ClientsLists from './components/pages/AdminManagement/ClientsLists';
import UpdateClient from './components/pages/AdminManagement/UpdateClient';
import SpocCreate from './components/pages/AdminManagement/SpocCreate';
import ClientDetails from './components/pages/AdminManagement/ClientDetail';
import SpocUpdate from './components/pages/AdminManagement/SpocUpdate';
import { CreateJob } from './components/CreateJob';
import { JobList } from './components/pages/JobList';
import { ViewJobs } from './components/pages/ViewJobs';
import AdvanceSearch from './components/pages/Candidates/Candidate Search/AdvanceSearch';
import ListCandidate from './components/pages/Candidates/Candidate Search/ListCandidate';
import ViewCandidate from './components/pages/Candidates/ViewCandidate';
import ImportCandidate from './components/pages/AdminManagement/ImportCandidate';
import ResumeProcess from './components/pages/AdminManagement/ResumeProcess';
import ImportInfo from './components/pages/AdminManagement/ImportInfo';
import { AccountRouter } from './components/pages/Candidates/Candidate Create Portal/AccountRouter';
import StatusList from './components/pages/AdminManagement/StatusList';
import { ProfileActionList } from './components/pages/ProfileAction/ProfileActionList';

import { Eod } from './components/pages/Eod';
import Account from './components/pages/Account';

import { Test } from './components/pages/Test';
import Loading from './components/pages/Loading';
import Logout from './components/pages/Logout';
import Forbidden from './components/pages/Forbidden';
import SessionHistory from './components/pages/session/SessionHistory';
import { SessionLogs } from './components/pages/session/SessionLogs';
import { LogHistory } from './components/pages/session/LogHistory';
// import { EodSubmissionReport } from './hooks/DownLoadExcel/EodSubmissionReport';
import { EodReport } from './components/pages/EODSubmission';
import Dashboard from './components/pages/Dashboard';
// import { RecruitmentReport } from './components/pages/RecruitmentReports';
import { Notification } from './components/pages/Notification';
import { ProfileActionHistory } from './components/pages/ProfileActionHistory';
import { RecruitmentTableFilterReport } from './components/pages/RecruitmentTableFilterReport';
import { TestFetchJobHistory } from './components/pages/TestFetchJobHistory';
import { TestFecthStatus } from './components/pages/TestFecthStatus';
import { ConsolidatedReports } from './components/pages/ConsolidatedReports';
import { CandidateProfiles } from './components/pages/AdminManagement/CandidateProfiles';
import { RecuriterStatus } from './components/pages/RecuriterStatus';



function App() {

  const { isAuth, currentUser, popup, handlePopupConfirm, handlePopupCancel } = useContext(DContext)
  const dialogRef = useRef()
  const location = useLocation()

  useEffect(() => {
    if (popup.visible) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [popup.visible]);

  const renderHomepage = () => {
    if (isAuth) {
      if (currentUser?.role === 'superadmin') {
        return <SuperAdminsDashboard />
      }
      else if (currentUser?.role === "helpdesk") {
        return <HelpDeskDashboard />
      }
      else if (currentUser?.role === "admin") {
        return <Dashboard />
      }
      else if (currentUser?.role === "manager") {
        return <Dashboard />
      }
      else if (currentUser?.role === "recruiter") {
        return <RecruiterDashboard />
      }
      else if (currentUser?.role === "teamlead") {
        return <TeamLeadDashboard />
      }
      else {
        return <Home />
      }
    }
    else return <Home />
  }

  if (isAuth == null || !currentUser) {
    return <Loading />
  }


  const handleLocation = () => {
    const path = location.pathname;

    // Matches /candidate-profile/any-id or /consolidated-reports
    return path.startsWith('/candidate-profile/') || path.startsWith('/recuriter-status/') || path === '/consolidated-reports';
  }

  const hideHeader = location.pathname === "/create-candidate" || location.pathname.startsWith("/update-account/")

  return (
    <div className="container-fluid p-0">
      {!hideHeader && <Header />}
      <div className={`px-2 mx-auto ${handleLocation() ? "max-w-full" : hideHeader ? "max-w-full" : "max-w-7xl"
        }`}>

        <Routes>
          {/*  */}
          <Route path="/" element={renderHomepage()} />
          <Route path="/signin" element={isAuth ? renderHomepage() : <Login />} />
          <Route path='/company-account' element={isAuth ? <Organisation /> : <Login />} />
          <Route path='/create-users' element={isAuth ? <UsersAccountCreate /> : <Login />} />
          <Route path='/list-users' element={isAuth ? <UserManagement /> : <Login />} />
          <Route path='/update-users/:id' element={isAuth ? <UpdateUsers /> : <Login />} />

          <Route path='/create-client' element={(isAuth && ["admin", "manager", "teamlead"].includes(currentUser.role)) ? <ClientCreate /> : <Login />} />
          <Route path='/list-clients' element={(isAuth && ["admin", "manager", "teamlead", "recruiter"].includes(currentUser.role)) ? <ClientsLists /> : <Login />} />
          <Route path='/update-client/:clientId' element={isAuth ? <UpdateClient /> : <Login />} />
          <Route path='/clientDetail/:clientId' element={isAuth ? <ClientDetails /> : <Login />} />

          <Route path='/create-spoc/:clientId' element={isAuth ? <SpocCreate /> : <Login />} />
          <Route path='/update-spoc/:spocId' element={isAuth ? <SpocUpdate /> : <Login />} />

          <Route path='/list-status' element={isAuth ? (["admin", "manager"].includes(currentUser.role) ? <StatusList /> : <Forbidden />) : <Login />} />

          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-condition' element={<TermsAndConditions />} />
          <Route path='/about-us' element={<AboutUs />} />

          {/* Testing Data */}
          <Route path='/profile-action-history' element={<ProfileActionHistory />} />
          <Route path='/test-jobs' element={<TestFetchJobHistory />} />
          <Route path='/test-status' element={<TestFecthStatus />} />

          {/* candidates */}
          <Route path='/list-candidates' element={isAuth ? <ListCandidate /> : <Login />} />
          <Route path='/candidate/:id' element={isAuth ? <ViewCandidate /> : <Login />} />
          <Route path='/pro-search' element={isAuth ? <AdvanceSearch /> : <Login />} />
          <Route path='/import-candidate' element={isAuth ? <ImportCandidate /> : <Login />} />
          <Route path='/import-resume' element={isAuth ? <ResumeProcess /> : <Login />} />
          <Route path='/import-info' element={isAuth ? <ImportInfo /> : <Login />} />
          <Route path="/update-account/:page" element={isAuth ? <AccountRouter /> : <Login />} />
          <Route path="/create-candidate" element={isAuth ? <AccountRouter /> : <Login />} />

          <Route path='/create-job' element={isAuth ? <CreateJob /> : <Login />} />
          <Route path='/update-job/:id' element={isAuth ? <CreateJob /> : <Login />} />
          <Route path='/list-jobs' element={isAuth ? <JobList /> : <Login />} />
          <Route path='/view-jobs/:id' element={isAuth ? <ViewJobs /> : <Login />} />
          <Route path='/eod-reports' element={isAuth ? <Eod /> : <Login />} />
          {/* <Route path='/eod-submission-reports' element={isAuth ? <EodSubmissionReport/> : <Login />} /> */}
          <Route path='/eod-submission-reports' element={isAuth ? <EodReport /> : <Login />} />


          <Route path='/session-history' element={isAuth ? <SessionHistory /> : <Login />} />
          <Route path='/session-logs' element={isAuth ? <SessionLogs /> : <Login />} />
          <Route path="/fetch-log-history/:id" element={isAuth ? <LogHistory /> : '*'} />

          {/* profile Action */}
          <Route path='/profile-action' element={isAuth ? <ProfileActionList /> : <Login />} />

          <Route path='/notification' element={isAuth ? <Notification /> : <Login />} />

          <Route path='/test' element={isAuth && <Test />} />
          {/* <Route path='/profile-action' element={isAuth ? <ProfileActionList /> : <Login />} /> */}
          <Route path='/dashboard' element={isAuth ? <Dashboard /> : <Login />} />

          {/*  Recruitement Report */}
          {/* <Route path='/recruitment' element={isAuth ? <RecruitmentReport /> : <Login />} /> */}
          {/* Recruitment date filter report */}
          <Route path='/recruitment' element={isAuth ? <RecruitmentTableFilterReport /> : <Login />} />

          <Route path='/recuriter-status/:jobId' element={isAuth ? <RecuriterStatus /> : <Login />} />
          <Route path='/candidate-profile/:jobId/:recuriterId' element={isAuth ? <CandidateProfiles /> : <Login />} />
          <Route path='/consolidated-reports' element={isAuth ? <ConsolidatedReports /> : <Login />} />

          {/* Account routes */}
          <Route path='/account' element={isAuth ? <Account /> : <Login />} />
          <Route path='/logout' element={isAuth ? <Logout /> : <Home />} />

          <Route path='*' element={<PageNotFound />} />

          {/* <Route path='/submissionReports' element={isAuth ? <SubmissionOverallReport /> : <Login />} /> */}
        </Routes>
      </div>

      {!hideHeader && <Footer />}
      {/* <Footer /> */}


      {/* 🔔 Global Popup Dialog */}

      <dialog
        ref={dialogRef}
        className="rounded-lg p-6 max-w-md w-full backdrop:bg-black/30 bg-white shadow-xl"
      >
        <p className="text-gray-800 mb-4 text-base">{popup.message}
          {popup.fileName && (
            <span className="block mt-1 font-semibold text-blue-600">
              "{popup.fileName}"
            </span>
          )}
        </p>

        {popup.type === "alert" && (
          <div className="text-center">
            <button
              onClick={handlePopupConfirm}
              className="px-5 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-md"
            >
              OK
            </button>
          </div>
        )}

        {popup.type === "confirm" && (
          <div className="flex justify-end gap-4">
            <button
              onClick={handlePopupCancel}
              className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded"
            >
              Cancel
            </button>
            <button
              onClick={handlePopupConfirm}
              className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded"
            >
              OK
            </button>
          </div>
        )}

        {popup.type === "delete" && (
          <div className="flex justify-end gap-4">
            <button
              onClick={handlePopupCancel}
              className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded"
            >
              Cancel
            </button>
            <button
              onClick={handlePopupConfirm}
              className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded"
            >
              Delete
            </button>
          </div>
        )}
      </dialog>


    </div>
  );
}

export default App;
